module.exports = __webpack_public_path__ + "img/product-add-success.748858b3.png";